<div class="example-preview">
    <form  [formGroup]="addCompanySettingsForm" autocomplete="off" >           
        <div>
            <div class="form-group row">
                <div class="col-md-4">
                    <label>Default sort in app</label>
                </div>

                <div class="col-md-8">
                    <mat-radio-group formControlName="sortBy" fxLayout="column" fxLayoutGap=".25rem" [(ngModel)]="sortBy">
                    <mat-radio-button [value]="'1'">By Name (A-Z)</mat-radio-button>
                    <mat-radio-button [value]="'0'">By Location (Nearest first)</mat-radio-button>
                    <br>
                        <mat-error *ngIf="isControlHasError('defaultSort', 'required')">Default Sort is required</mat-error>
                        </mat-radio-group>
                </div>    
            </div>
            <div style="height: 30px;"></div>
            <div class="form-group row">
                <div class="col-md-4">
                    <label>Enforce live location capture while adding from app</label>
                </div>
                <div class="col-md-8">
                    <mat-checkbox #checkbox  formControlName="enforceLiveLocCapture" [(ngModel)]="enforceLiveLocCapture" checked></mat-checkbox> <label class="ml-3">Yes</label> 
                    <br>
                    <mat-hint class="form-error">Select to enforce location capture when adding Customer</mat-hint>   
                </div>
            </div>
            <div style="height: 20px;"></div>
            <div class="form-group row">
                <div class="col-md-4">
                    <label>Ownership can be assigned to </label>
                </div>

                <div class="col-md-8">
                    <mat-radio-group formControlName="chooseCompanyOwnerFlag" fxLayout="column" fxLayoutGap=".25rem" [(ngModel)]="chooseCompanyOwnerFlag">
                    <mat-radio-button [value]="'1'">Up in the hierarchy</mat-radio-button>
                    <mat-radio-button [value]="'2'">Down the hierarchy</mat-radio-button>
                    <mat-radio-button [value]="'3'">Any user</mat-radio-button>
                    <mat-error *ngIf="isControlHasError('chooseCompanyOwnerFlag', 'required')">Select One</mat-error>
                    </mat-radio-group>
                </div> 
            </div>

            <div style="height: 10px;"></div>
            <div class="form-group row">
                <div class="col-md-4">
                    <label class="col-form-label form-padding-top-25">Rename Customer?</label>
                </div>
                <div class="col-md-8">
                    <mat-form-field appearance="standard" class="input-100" >
                        <input matInput #input2  maxlength="25" formControlName="singularName" [(ngModel)]="singularName" ktAutoTrimSpaces>
                        <mat-hint align="end" style="color: rgba(0,0,0,.54)">{{input2.value?.length || 0}}/25</mat-hint>
                        <mat-error *ngIf="isControlHasError('singularName', 'required')">Rename Customer cannot be blank</mat-error>
                        <mat-error *ngIf="isControlHasError('singularName', 'maxlength')"><strong>Maximum 25 characters</strong></mat-error>
                        <mat-icon  matSuffix [ngStyle]="{'color':'#3699FF'}">text_fields</mat-icon> 
                    </mat-form-field>                    
                </div>
                
            </div>
            <div style="height: 10px;"></div>

            <div class="form-group row">
                <div class="col-md-4">
                    <label class="col-form-label form-padding-top-20">What would be the plural?</label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="input-100" >
                        <input matInput #input  maxlength="25" formControlName="pruralName" [(ngModel)]=pruralName ktAutoTrimSpaces>    
                        <mat-hint align="end" style="color: rgba(0,0,0,.54)"> {{input.value?.length || 0}}/25</mat-hint>
                        <mat-error *ngIf="isControlHasError('pruralName', 'required')">Plural cannot be blank</mat-error>
                        <mat-error *ngIf="isControlHasError('pruralName', 'maxlength')"><strong>Maximum 25 characters</strong></mat-error>
                        <mat-icon  matSuffix [ngStyle]="{'color':'#3699FF'}">text_fields</mat-icon> 
                    </mat-form-field>                    
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-12">
                    <span style="color:red">{{errorMes}}</span>
                </div>
                
            </div>
                
        </div>
        <div class="row" ktMargin [marginBottom]="'20px'"></div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" [disabled]='isDisabled()' (click)="Cancel()">Cancel</button>
            <button type="button" class="btn btn-primary" [disabled]='isDisabled()' (click)="Save()">Save</button>
        </div>
        
    </form> 
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" size="default" type="ball-spin-clockwise">  
    <p style="color: white">Fetching Data... </p>  
</ngx-spinner>
